const ExpandSvg = ({
  height = 40,
  width = 40,
  viewBox = '0 0 40 40',
  rx = 20,
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  rx?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <rect width={width} height={height} rx={rx} fill="#227A92" />
      <path
        d="M18.3337 25.8333H14.167V21.6667M21.667 14.1667H25.8337V18.3333"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ExpandSvg;
